import {Reducer} from "redux";
import {RESET_CREDENTIALS, SET_CREDENTIALS} from "../action_types/credentialActionTypes";

/**
 * Reducer state
 */
interface ICredentialReducerState {
    readonly instanceID: string,
    readonly password: string,
}

/**
 * Initial reducer state
 * @type {{instanceID: string; password: string}}
 */
const initialState: ICredentialReducerState = {
    instanceID: '',
    password: '',
};

/**
 * Credentials action reducers
 */
const CredentialReducer: Reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CREDENTIALS: {
            return {
                ...state,
                instanceID: action.instanceID,
                password: action.password,
            }
        }

        case RESET_CREDENTIALS: {
            return {
                ...state,
                instanceID: '',
                password: '',
            }
        }

        /**
         * Default reducer
         */
        default:
            return state;
    }
};

export default CredentialReducer;


// WEBPACK FOOTER //
// ./src/reducers/credentialReducer.ts